(() => {
  const root = window.Shopify?.routes?.root || '/';
  const signature = cart => JSON.stringify([cart.total_price,cart.currency,cart.items.map(i=>[i.key,i.quantity])]);
  async function json(url, options) {
    const response = await fetch(root + url, options);
    if (!response.ok) throw new Error('No pudimos consultar el envío. Revisa tu código postal y estado o confírmalo al pagar.');
    return response.json();
  }
  function clear(container) {
    container.dataset.request = String(Number(container.dataset.request || 0) + 1);
    container.querySelector('[data-delivery-result]').textContent = '';
    container.querySelector('button').disabled = false;
  }
  document.addEventListener('input', event => {
    const container = event.target.closest('[data-delivery-estimate]');
    if (container) clear(container);
    else if (event.target.matches('[name="updates[]"],.qty-adjuster input')) document.querySelectorAll('[data-delivery-estimate]').forEach(clear);
  });
  document.addEventListener('change', event => {
    const container = event.target.closest('[data-delivery-estimate]');
    if (container) clear(container);
  });
  document.addEventListener('click', event => {
    if (event.target.closest('.qty-adjuster__up,.qty-adjuster__down,.qty-adjuster__remove')) document.querySelectorAll('[data-delivery-estimate]').forEach(clear);
  }, true);
  document.addEventListener('DOMContentLoaded', () => {
    if (window.jQuery) window.jQuery(window).on('cc-cart-updated.deliveryEstimate', () => document.querySelectorAll('[data-delivery-estimate]').forEach(clear));
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-delivery-calculate]');
    if (!button) return;
    const container = button.closest('[data-delivery-estimate]');
    const output = container.querySelector('[data-delivery-result]');
    const zip = container.querySelector('[data-delivery-zip]').value.trim();
    const province = container.querySelector('[data-delivery-state]').value;
    if (!/^\d{5}$/.test(zip) || !province) { output.textContent = 'Escribe los 5 dígitos del código postal y selecciona un estado.'; return; }
    const token = String(Number(container.dataset.request || 0) + 1);
    container.dataset.request = token;
    button.disabled = true;
    output.textContent = 'Consultando tarifas…';
    try {
      const cart = await json('cart.js');
      if (!cart.item_count) throw new Error('Agrega un producto para consultar el envío.');
      const query = new URLSearchParams({'shipping_address[zip]':zip,'shipping_address[country]':'Mexico','shipping_address[province]':province});
      await json('cart/prepare_shipping_rates.json?' + query, {method:'POST'});
      let rates = null;
      for (let attempt=0;attempt<10;attempt++) {
        if (container.dataset.request !== token) return;
        const result = await json('cart/async_shipping_rates.json?' + query);
        if (result) { rates = result.shipping_rates; break; }
        await new Promise(resolve=>setTimeout(resolve,1000));
      }
      const current = await json('cart.js');
      if (container.dataset.request !== token || !container.isConnected) return;
      if (signature(current)!==signature(cart)) throw new Error('Tu carrito cambió. Vuelve a consultar el envío.');
      if (!rates?.length) throw new Error('No hay una tarifa disponible para esta consulta. Confirma la dirección y las opciones al pagar.');
      const money = cents => new Intl.NumberFormat('es-MX',{style:'currency',currency:cart.currency}).format(cents/100);
      output.replaceChildren();
      const subtotal = document.createElement('p'); subtotal.textContent = 'Productos: ' + money(cart.total_price); output.append(subtotal);
      const list = document.createElement('ul');
      for (const rate of rates) {
        const cost = Math.round(Number(rate.price)*100);
        if (!Number.isFinite(cost) || cost < 0) continue;
        const row = document.createElement('li'); row.textContent = rate.name + ': ' + money(cost) + '. Productos + envío: ' + money(cart.total_price + cost); list.append(row);
      }
      if (!list.children.length) throw new Error('No pudimos verificar la tarifa. Confirma el envío al pagar.');
      output.append(list);
    } catch (error) {
      if (container.dataset.request === token) output.textContent = error.message;
    } finally {
      if (container.dataset.request === token) button.disabled = false;
    }
  });
})();
